import { OnInit } from '@angular/core';
import { CommonDataSource } from "@app/workflow-common/services/CommonDataSource";
import * as moment from "moment";
import { BsModalRef } from "ngx-bootstrap";
import { WorkflowhttpService } from "@app/workflow-common/services/workflowhttp.service";
var HistoryTaskStatusModalComponent = /** @class */ (function () {
    function HistoryTaskStatusModalComponent(modalRef, dataService) {
        this.modalRef = modalRef;
        this.dataService = dataService;
        this.startDate = undefined;
        this.endDate = undefined;
        this.isTaskOnSameDate = false;
        this.showSuccessStatus = false;
        this.showFailedStatus = false;
        this.showSkippedStatus = false;
        this.showFullDetails = false;
        this.showLessDetails = false;
        this.communicationId = undefined;
        this.showContent = '';
        this.emailMessageData = {};
        this.smsMessageData = {};
    }
    HistoryTaskStatusModalComponent.prototype.ngOnInit = function () {
        var _a = this.task, taskParams = _a.taskParams, startDate = _a.startDate, endDate = _a.endDate, status = _a.status;
        this.title = CommonDataSource.capitalize(taskParams.block_name.replace('Block', ''));
        this.startDate = moment.utc(startDate['date']).local();
        this.endDate = endDate ? moment.utc(endDate['date']).local() : null;
        if (this.endDate) {
            this.isTaskOnSameDate = this.startDate.format('YYYY-MM-DD') === this.endDate.format('YYYY-MM-DD');
        }
        this.showSuccessStatus = status === 'success';
        this.showFailedStatus = status === 'failed';
        this.showSkippedStatus = status === 'skipped';
        if (taskParams.hasOwnProperty('communicationId')) {
            this.communicationId = taskParams["communicationId"];
        }
        if ((taskParams.block_name.startsWith('email') || taskParams.block_name.startsWith('sms')) && this.communicationId) {
            this.showFullDetails = true;
        }
    };
    HistoryTaskStatusModalComponent.prototype.viewLessDetails = function () {
        this.showFullDetails = true;
        this.showLessDetails = false;
        this.showContent = '';
    };
    HistoryTaskStatusModalComponent.prototype.viewFullDetails = function (id) {
        var _this = this;
        if (!id) {
            return;
        }
        var taskParams = this.task.taskParams;
        if (taskParams.block_name.startsWith('email')) {
            if (this.emailMessageData.hasOwnProperty('fromEmail')) {
                this.showFullDetails = false;
                this.showLessDetails = true;
                this.showContent = 'email';
                return;
            }
            this.dataService.getCommunicationEmailDetails(id).subscribe(function (resp) {
                if (!resp)
                    return;
                _this.showFullDetails = false;
                _this.showLessDetails = true;
                _this.showContent = 'email';
                _this.emailMessageData['fromEmail'] = resp.fromEmail;
                _this.emailMessageData['toEmail'] = resp.toEmail;
                _this.emailMessageData['ccEmail'] = resp.ccEmail;
                _this.emailMessageData['bccEmail'] = resp.bccEmail;
                _this.emailMessageData['subject'] = resp.subject;
                _this.emailMessageData['message'] = resp.message;
                _this.emailMessageData['sentBy'] = resp.sentBy;
                _this.emailMessageData['status'] = resp.status;
            });
        }
        if (taskParams.block_name.startsWith('sms')) {
            this.showFullDetails = false;
            this.showLessDetails = true;
            this.showContent = 'sms';
            this.smsMessageData['recipients'] = taskParams.status.status;
            this.smsMessageData['message'] = taskParams.status.message;
        }
    };
    return HistoryTaskStatusModalComponent;
}());
export { HistoryTaskStatusModalComponent };
